import React from "react";
import { Link } from "react-router-dom";

import ModalInfo from "../../ModalInfo";
import RatingActivity from "../../RatingActivity";

class Page2 extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    visible: true,
    modalShow: true,
    instructions: (
      <div>
        <p>
          How can you develop your emotional intelligence? Let’s begin by
          getting an idea of your confidence levels against each of the five
          elements. Rate your confidence from low-high. Click on each element
          for ideas to develop your emotional intelligence attributes.
        </p>
      </div>
    ),
    q1Grade: 0,
    q2Grade: 0,
    q3Grade: 0,
    q4Grade: 0,
    q5Grade: 0,
  };

  checkPageVisibility(pageNum) {
    if (pageNum == 3) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  setq1Grade = (grade) => {
    this.setState({
      q1Grade: grade,
    });
    this.props.updatePdf1(grade);
  };

  setq2Grade = (grade) => {
    this.setState({
      q2Grade: grade,
    });
    this.props.updatePdf2(grade);
  };

  setq3Grade = (grade) => {
    this.setState({
      q3Grade: grade,
    });
    this.props.updatePdf3(grade);
  };

  setq4Grade = (grade) => {
    this.setState({
      q4Grade: grade,
    });
    this.props.updatePdf4(grade);
  };

  setq5Grade = (grade) => {
    this.setState({
      q5Grade: grade,
    });
    this.props.updatePdf5(grade);
  };

  render() {
    let modalClose = () => this.setState({ modalShow: false });

    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0  d-md-block">
                    Develop Emotional Intelligence
                  </h3>
                </li>
                <li className="nav-item"></li>
              </ul>
              <ul className="nav navbar-nav ml-auto">
                <div>
                  <i
                    className="fas fa-info-square fa-3x"
                    onClick={() => this.setState({ modalShow: true })}
                  ></i>
                </div>
              </ul>
            </nav>
            <br />
            <br />
            <RatingActivity
              title="Self-awareness"
              modalTitle={
                <p>
                  Ideas to develop your <strong>Self-awareness</strong>
                </p>
              }
              modalDescription={
                <div>
                  <p>
                    Have a go at the Values and Strengths activity in{" "}
                    <Link to="/Module1" target="_blank">
                      ‘I have no idea what I want to do’
                    </Link>{" "}
                    module. Getting feedback is important for developing
                    self-awareness – after all, this is often the only way that
                    you can find out about issues that you may not be able to
                    face directly. Ask a trusted friend, family member or
                    colleague about how you come across.
                  </p>
                </div>
              }
              grade={this.state.q1Grade}
              setRatingGrade={this.setq1Grade}
            />
            <br />
            <br />
            <RatingActivity
              title="Self-regulation"
              modalTitle={
                <p>
                  Ideas to develop your <strong>Self-regulation</strong>
                </p>
              }
              modalDescription={
                <div>
                  <p>
                    One of the best things you can do is mentally stop yourself,
                    and look at the situation. Ask yourself why you feel
                    frustrated. Write it down, and be specific. Take a moment to
                    realise that things won't always go your way. If they did,
                    life would be a straight road instead of one with hills and
                    valleys, ups and downs, right? And it's the hills and
                    valleys that often make life so interesting.
                  </p>
                </div>
              }
              grade={this.state.q2Grade}
              setRatingGrade={this.setq2Grade}
            />
            <br />
            <br />
            <RatingActivity
              title="Motivation"
              modalTitle={
                <p>
                  Ideas to develop your <strong>Motivation</strong>
                </p>
              }
              modalDescription={
                <p>
                  Part of being self-motivated is having good levels of
                  self-assurance, self-confidence, and self-efficacy. Think
                  about your achievements, be aware of what you’re good at and
                  seek out mentors who model the qualities you desire. If you
                  struggle to motivate yourself, seek out team projects and draw
                  on the energy of people around you.
                </p>
              }
              grade={this.state.q3Grade}
              setRatingGrade={this.setq3Grade}
            />
            <br />
            <br />
            <RatingActivity
              title="Empathy"
              modalTitle={
                <p>
                  Ideas to develop your <strong>Empathy</strong>
                </p>
              }
              modalDescription={
                <p>
                  Put aside your viewpoint and try and see things from others
                  perspective. A simple technique to do this is to ask the other
                  person what they would do or how they would feel about a
                  particular situation.
                </p>
              }
              grade={this.state.q4Grade}
              setRatingGrade={this.setq4Grade}
            />
            <br />
            <br />
            <RatingActivity
              title="Social Skills"
              modalTitle={
                <p>
                  Ideas to develop your <strong>Social Skills</strong>
                </p>
              }
              modalDescription={
                <p>
                  Develop your social skills by being active. Go to networking
                  events and meet employers, students and alumni. Informal
                  engagement is important too, consider volunteering, joining a
                  club or a society. The more you engage the more your
                  confidence will grow.
                </p>
              }
              grade={this.state.q5Grade}
              setRatingGrade={this.setq5Grade}
            />

            <ModalInfo
              show={this.state.modalShow}
              onHide={modalClose}
              title="INSTRUCTIONS"
              content={this.state.instructions}
            />
            <br />
            <br />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page2;
